import React from "react";
import { Select as AntdSelect, SelectProps } from "antd";
import CreatableSelect from "react-select/creatable";
import styled from "@emotion/styled";
import { CreatableProps } from "react-select/creatable";

const StyledCreatableSelect = styled(CreatableSelect)`
  .valueContainer {
    background: red;
  }
`;
const Select = (
  props: Partial<SelectProps> & {
    creatableProps: any;
    isCreatable: boolean;
  }
) => {
  if (props.isCreatable) {
    return (
      <StyledCreatableSelect
        styles={{
          control: (base, _) => {
            return {
              ...base,
              borderColor: _.isFocused
                ? "#005eff !important"
                : base.borderColor,
              boxShadow: _.isFocused ? " 0 0 0 1px #005eff" : base.boxShadow,
            };
          },
        }}
        {...props}
        {...props.creatableProps}
        options={props.options}
        isCreatable
      ></StyledCreatableSelect>
    );
  }
  return <AntdSelect {...props}></AntdSelect>;
};

export default Select;
